import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <section ref={ref} className="relative h-screen w-full overflow-hidden bg-night-900 flex items-center" data-id="element-51">
      {/* Parallax Background Image */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 w-full h-full" data-id="element-52">
        <div className="absolute inset-0 bg-night-900/40 z-10" data-id="element-53" />{' '}
        {/* Dark overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-night-900 via-night-900/60 to-transparent z-10" data-id="element-54" />{' '}
        {/* Bottom gradient */}
        <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=1920&q=80" alt="Perfect Smile" className="w-full h-full object-cover object-center" data-id="element-55" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-6 md:px-12 w-full pt-20" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="max-w-3xl" data-id="element-57">
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white leading-tight mb-6" data-id="element-58">
            El Arte de una <br data-id="element-59" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-60">
              Sonrisa Impecable
            </span>
          </h1>

          <p className="font-sans text-lg md:text-xl text-pearl/90 mb-10 max-w-xl font-light leading-relaxed" data-id="element-61">
            Tecnología dental avanzada diseñada para quienes no se conforman con
            menos. Experimenta la odontología de élite.
          </p>

          <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-gold text-night-900 px-8 py-4 rounded-sm font-semibold text-sm md:text-base uppercase tracking-widest hover:bg-gold-light transition-colors shadow-[0_0_20px_rgba(212,175,55,0.3)]" data-id="element-62">
            Reservar Sesión VIP
          </motion.a>
        </motion.div>
      </div>
    </section>;
}